
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/[feature]",
      function () {
        return require("private-next-pages/tools/[feature].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/[feature]"])
      });
    }
  